import type { ItemMetadata } from "./metadata";

export type Media = {
	id: string;
	mimeType?: string;
	url: string;
	type: "image" | "audio" | "video" | "IMAGE" | "AUDIO" | "VIDEO" | "images";
	transcript?: string;
	transcription?: string;
};

export type Passage = {
	title: string;
	paragraphs?: {
		number: number;
		text: string;
	}[];
	media?: Media[];
};

export type Slide = {
	title?: string;
	media?: Media[];
	passage?: Passage;
};

export type Professor = {
	name: string;
	avatar: Media;
	questionTitle?: string;
	questionBody?: string;
};

export type Discussion = {
	student: Professor;
	post: string;
};

export type ItemHighlight = {
	highlightType: "paragraph" | "text";
	highlightText?: string;
	paragraphNumber: number;
};

export type ChoiceStats = {
	nFs: number;
	correctAttempts: number;
	overAllAttempts: number;
	correctFirstAttempts: number;
};

export type Choice = {
	id: string;
	text?: string;
	order?: number;
	isCorrect?: boolean;
	stats?: ChoiceStats;
	position?: number;
	explanation?: string | null;
	explanation_mandarin?: string | null;
	explanation_japanese?: string | null;
	numFirstSelections?: number;
	points?: number;
};

export type ItemStem = {
	text?: string;
	media?: Media[];
};
export type InstructionType = {
	text: string;
};
export type BaseItemContent = {
	stem?: ItemStem;
	instruction?: string | InstructionType;
	minChoiceCount?: number;
	maxChoiceCount?: number;
	paragraphNumber?: number;
	discussion?: Discussion[];
	insertSentence?: string | null;
	media?: Media[];
	parentId?: number;
	highlights?: ItemHighlight[] | null;
	stimulus?: StimulusContent;
	title?: string;
	professor?: Professor;
	className?: string;
	passage?: Passage;
	slides?: Slide[];
	metadata?: ItemMetadata;
};

export type NumChoicesRequired = {
	min: number;
	max: number;
};

export type CorrectResponseItem = {
	id: string;
	order?: number;
	text?: string;
	audio?: Media;
};

export type StimulusContent = {
	type: "audio" | "text" | "audio_and_text" | "AUDIO" | "TEXT" | "IMAGE";
	text?: string | null;
	displayTranscript?: string | null;
	segments?: {
		id: number | string;
		text: string;
	}[];
	stem?: ItemStem;
	title?: string;
	professor?: Professor;
	instruction?: string | InstructionType;
	className?: string;
	passage?: Passage;
	media?: Media[];
	slides?: Slide[];
};
